import React, { useEffect } from 'react';
import { useT } from 'talkr';
import s from './index.module.scss';
import steps from '../../../survey/steps';
import common from '../../index.module.scss';

function BeforeAfterB () {
	const { T } = useT();
	useEffect(() => {
		steps.setStepStatus({
			stepName: 'before_after_b',
			stepStatus: true
		});
	}, []);

	function goForward () {
		steps.navigate.forward({
			preventAction: 500
		});
	}

	return (
		<div className={common.step}>
			<div className={s.firstPageQuestionA_wrapper}>
				<div className={s.firstPageQuestionA}>
					<div className={s.firstPageQuestionA_description}>
						{T('firstPageQuestion_description')}
					</div>
					<div className={s.firstPageQuestionA_title}>
						{T('firstPageQuestionA_title')}
					</div>
					<div className={s.firstPageQuestionA_image}>
						<div className={s.firstPageQuestionA_labels}>
							<div className={s.firstPageQuestionA_label}>{T('firstPageQuestionA_label_1')}</div>
							<div className={s.firstPageQuestionA_label}>{T('firstPageQuestionA_label_2')}</div>
							<div className={s.firstPageQuestionA_label}>{T('firstPageQuestionA_label_3')}</div>
							<div className={s.firstPageQuestionA_label}>{T('firstPageQuestionA_label_4')}</div>
						</div>
						<div className={s.firstPageQuestionA_text}>
							<div className={s.firstPageQuestionA_textBefore}>{T('firstPageQuestionA_textBefore')}</div>
							<div className={s.firstPageQuestionA_textAfter}>{T('firstPageQuestionA_textAfter')}</div>
						</div>
					</div>
				</div>
				<div className={s.stepControlWrapper}>
					<button onClick={goForward} className={s.button} type="button">{T('firstPageQuestionA_button')}</button>
				</div>
			</div>
		</div>
	);
}

export default BeforeAfterB;
